import React from 'react'
import clsx from 'clsx'

import { APP_LOADER_COLOR, AppLoaderProps } from './AppLoaderProps'

import './AppLoaderStyles.scss'


/**
 * ATOM - Komponent Loadera, projekt oraz style zaczerpnięte ze strony: https://cssloaders.github.io/
 * @param {String | Number} height - Rozmiar loadera, podawany jako string (np. 1em, 50%) lub jako liczba 40, 60
 * @param {String | Number} barWidth - Grubość loadera, podawany jako string (np. 1em, 50%) lub jako liczba 40, 60
 * @param {APP_LOADER_COLOR} - Kolor loadera, zgodny z projektem
 * @param {String} ariaLabel - Alternatywny tekst dla czytników ekranu
 * @param {String} className - Dodatkowa klasa pozwalająca dodać customowe właściwości
*/
const AppLoader = (props: AppLoaderProps) => {
   const  { className, ariaLabel, height, barWidth, color = APP_LOADER_COLOR.PRIMARY } = props
   const size = height ? (typeof height === 'number' ? `${height}px` : height) : 'auto'
   const bar = barWidth ? (typeof barWidth === 'number' ? `${barWidth}px` : barWidth) : '8px'
 
   const style: React.CSSProperties = {
     height: size,
     aspectRatio: '1 / 1',
     '--loader-bar-width': bar,
   } as React.CSSProperties
 

   return (
      <div
         className={clsx('app-loader',`app-loader--${color.toLowerCase()}`, className)}
         style={style}
         role="status"
         aria-live="polite"
         aria-label={ariaLabel || 'Ładowanie...'}
      />
   )
}
 
export default AppLoader